// extracted by mini-css-extract-plugin
export default {"aboutHeader":"OurServicesHeader_aboutHeader__WqPKw"};